<template>
  <div id="VodEnvTest">
    <el-row class="top-title">
      <el-col :span="24" class="top-title">
        <h2>点播环境配置检测</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="testItem" label="测试项"></el-table-column>
        <el-table-column label="HTTP">
          <template slot-scope="scope">
            <span v-if="scope.row.tips != '正在检测...'">
              <i class="el-icon-circle-check success" v-if="scope.row.flag"></i>
              <i class="el-icon-circle-close failure" v-else></i>
            </span>
            <span v-html="scope.row.tips"></span>
          </template>
        </el-table-column>
        <el-table-column label="HTTPS">
          <template slot-scope="scope">
            <span v-if="scope.row.tips1 != '正在检测...'">
              <i
                class="el-icon-circle-check success"
                v-if="scope.row.flag1"
              ></i>
              <i class="el-icon-circle-close failure" v-else></i>
            </span>
            <span v-html="scope.row.tips1"></span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
import Vue from 'vue'

import { $Url, sleep } from '../plugins/utils'

export default {
  name: 'VodEnvTest',
  data() {
    return {
      inTesting: '正在检测...',
      tableData: [
        {
          testItem: 'PC端加密视频切片A',
          url:
            '://ab-dts.videocc.net/e1851177df/0/1234567890123/5/64/b3/65_1/e1851177df8a3f2360a2d37d4264b365_1_0.ts',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: 'PC端加密视频切片U',
          url:
            '://uc-dts.videocc.net/e1851177df/0/1234567890123/5/64/b3/65_1/e1851177df8a3f2360a2d37d4264b365_1_0.ts',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: '移动端加密视频切片A',
          url:
            '://ab-mts.videocc.net/e1851177df/0/1234567890123/5/64/b3/65_1/e1851177df8a3f2360a2d37d4264b365_1_0.ts',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: '移动端加密视频切片U',
          url:
            '://uc-mts.videocc.net/e1851177df/0/1234567890123/5/64/b3/65_1/e1851177df8a3f2360a2d37d4264b365_1_0.ts',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: '移动端MP4访问域名',
          url: '://mpv.videocc.net/',
          flag: false,
          tips: '正在检测...',
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: 'PC端MP4访问域名',
          url: '://dpv.videocc.net/',
          flag: false,
          tips: '正在检测...',
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: 'PC端m3u8',
          url:
            '://hls.videocc.net/e1851177df/5/e1851177df8a3f2360a2d37d4264b365_3.m3u8',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: 'PC端m3u8备用',
          url:
            '://hls.videocc.net/e1851177df/5/e1851177df8a3f2360a2d37d4264b365_3.m3u8',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: '加密视频地址检测',
          url:
            '://share.polyv.net/front/video/preview?vid=e1851177df8a3f2360a2d37d4264b365_e',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: 'FLV播放访问域名',
          url: '://plvod01.videocc.net/',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: '管理后台访问',
          url: '://my.polyv.net/',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: '点播观看页访问',
          url: '://share.plvideo.cn/',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: '点播观看页分享页面访问',
          url: '://go.plvideo.cn/',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        },
        {
          testItem: '点播播放器统计访问',
          url: '://prtas.videocc.net/',
          tips: '正在检测...',
          flag: false,
          tips1: '正在检测...',
          flag1: false
        }
      ]
    }
  },
  mounted() {
    for (let i = 0; i < 3; i++) {
      sleep(1000)
      for (let index in this.tableData) {
        $Url('http' + this.tableData[index].url)
          .then(() => {
            let data = this.tableData[index]
            data.tips = '连接成功'
            data.flag = true
            Vue.set(this.tableData, index, data)
          })
          .catch(() => {
            let data = this.tableData[index]
            if (!data.flag) {
              data.tips = '连接失败'
              Vue.set(this.tableData, index, data)
            }
          })

        $Url('https' + this.tableData[index].url)
          .then(() => {
            let data = this.tableData[index]
            data.tips1 = '连接成功'
            data.flag1 = true
            Vue.set(this.tableData, index, data)
          })
          .catch(() => {
            let data = this.tableData[index]
            if (!data.flag1) {
              data.tips1 = '连接失败'
              Vue.set(this.tableData, index, data)
            }
          })
      }
    }
  }
}
</script>
<style>
h2 {
  color: white;
}
.success {
  color: #67c23a;
  font-size: 25px;
}
.failure {
  color: red;
  font-size: 25px;
}</style
>>
